<template>
  <div>
    <el-row>
      <el-col>
        <p>订单编号：{{ this.orderCode }}</p>
      </el-col>
    </el-row>
    <!-- <el-row>
            <el-col>
                <el-button size="small" @click="addProduct">新增产品</el-button>
            </el-col>
        </el-row> -->
    <!-- <el-row>
      <el-form size="small" :inline="true" class="demo-form-inline" style="margin: 0" :model="firstForm"
        @submit.native.prevent>
        <el-form-item label="产品名称：">
          <el-autocomplete class="inline-input" @keyup.enter.native="handelTab(1, $event)" ref="input1"
            v-model="firstForm.productName" :fetch-suggestions="querySearch" placeholder="请输入产品名称"
            :trigger-on-focus="false" @select="handleSelect" clearable></el-autocomplete>
        </el-form-item>
        <el-form-item label="单位：">
          <el-input style="width: 80px" v-model="addForm.TYPE_UNIT" disabled></el-input>
        </el-form-item>
        <el-form-item label="单价：">
          <label slot="label">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价：</label>
          <el-input @keyup.enter.native="handelTab(2, $event)" ref="input2" v-model="addForm.CURRENT_PRICE"
            v-if="BE_PRICE === 1" :disabled="isisdisabled" @input="validatPrice"></el-input>
          <el-input @keyup.enter.native="handelTab(2, $event)" ref="input2" v-model="addForm.CURRENT_PRICE" v-else
            disabled @input="validatPrice"></el-input>
        </el-form-item>
        <el-form-item label="订购数量：">
          <el-input @keyup.enter.native="handelTab(3, $event)" ref="input3" v-model="addForm.count"
            @input="countChange"></el-input>
        </el-form-item>
        <el-form-item label="总金额：">
          <el-input @keyup.enter.native="handelTab(4, $event)" ref="input4" v-model="addForm.totalFee"
            :disabled="isisdisabled" @input="validatTotal"></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <label slot="label">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</label>
          <el-input @keyup.enter.native="handelTabSp" ref="input5" v-model="addForm.comment" maxlength="20"
            show-word-limit></el-input>
        </el-form-item>
        <el-button size="small" @click="submitAdd()">确认</el-button>
        <el-button size="small" @click="finishEntry()">录入完成</el-button>
      </el-form>
    </el-row> -->
    <el-row>
      <el-col>
        <el-table border stripe :data="tableData" style="margin-top: 20px" @selection-change="handleSelectionChange" :span-method="objectSpanMethod">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column label="序号" type="index" width="50" :index="indexMethod"></el-table-column>
          <el-table-column label="产品编码" prop="PRODUCT_CODE" width="160"></el-table-column>
          <el-table-column label="产品名称" prop="PRODUCT_NAME"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="单价" prop="REAL_PRICE"></el-table-column>
          <el-table-column label="订购数量" prop="PRODUCT_COUNT">
            <template slot-scope="scope">
              <el-input v-model="scope.row.PRODUCT_COUNT" @change="setProductCount(scope.row)" clearable>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="送货数量" prop="NEED_COUNT"></el-table-column>
          <el-table-column label="总金额" prop="TOTAL_FEE"></el-table-column>
          <el-table-column label="备注" prop="PRODUCT_COMMENT"></el-table-column>
          <!-- <el-table-column label="操作" width="200px">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="editProduct(scope.row)" icon="el-icon-edit">修改</el-button>
              <el-button size="small" type="text" @click="deleteProduct(scope.row)" icon="el-icon-close"
                style="color: #f56c6c">删除</el-button>
              <el-button size="small" type="text" @click="sperateProduct(scope.row)">拆分</el-button>
            </template>
          </el-table-column> -->
          <el-table-column label="公司名称" prop="TC_NAME"></el-table-column>
          <el-table-column label="项目点-档口" prop="DK_NAME" width="100"></el-table-column>
          <el-table-column label="客户订购数量" prop="CUSTOMER_PRODUCT_COUNT"></el-table-column>
          <el-table-column label="供应商送货数量" prop="CUSTOMER_NEED_COUNT"></el-table-column>
          <el-table-column label="客户备注" prop="CUSTOMER_PRODUCT_COMMENT"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="medium" @click="copyAllProduct" type="primary" plain style="margin-top: 20px">移动商品</el-button>
        <el-button size="medium" @click="editAllProduct" type="primary" plain style="margin-top: 20px">批量修改</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px">
      <el-col>
        <el-steps :active="this.statusFlag" finish-status="success" v-show="this.statusFlag !== 0" :space="200">
          <el-step :title="item.T" :description="item.D" v-for="item in checkData" :key="item.value"></el-step>
        </el-steps>
        <h4 v-show="this.statusFlag === 0" style="color: #e6a23c">
          暂无流程记录信息
        </h4>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-dialog title="修改产品" center :visible.sync="editFormVisible" width="600px" :close-on-click-modal="false">
          <el-form :model="editForm" ref="editForm" size="small">
            <el-form-item label="产品名称：" :label-width="formLabelWidth">
              <span>{{ this.editForm.PRODUCT_NAME }}</span>
            </el-form-item>
            <el-form-item label="单位：" :label-width="formLabelWidth">
              <label slot="label">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位：</label>
              <span>{{ this.editForm.TYPE_UNIT }}</span>
            </el-form-item>
            <el-form-item label="单价：" :label-width="formLabelWidth">
              <label slot="label">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价：</label>
              <el-input @keyup.enter.native="submitEdit" v-model="editForm.REAL_PRICE" v-if="BE_PRICE === 1" @input="countFee"
                :disabled="isisdisabled"></el-input>
              <el-input @keyup.enter.native="submitEdit" v-model="editForm.REAL_PRICE" v-else disabled @input="countFee"></el-input>
            </el-form-item>
            <el-form-item label="订购数量：" :label-width="formLabelWidth">
              <el-input @keyup.enter.native="submitEdit" v-model="editForm.PRODUCT_COUNT" @input="countFee"></el-input>
            </el-form-item>
            <el-form-item label="总金额：" :label-width="formLabelWidth">
              <el-input @keyup.enter.native="submitEdit" v-model="editForm.TOTAL_FEE" @input="changePrice" :disabled="isisdisabled"></el-input>
            </el-form-item>
            <el-form-item label="备注：" :label-width="formLabelWidth">
              <label slot="label">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</label>
              <el-input @keyup.enter.native="submitEdit" v-model="editForm.PRODUCT_COMMENT" maxlength="20" show-word-limit></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="close">取 消</el-button>
            <el-button size="small" @click="submitEdit">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-dialog title="新增产品" center :visible.sync="addFormVisible" width="600px">
          <el-form :model="addForm" ref="addForm" size="small">
            <el-form-item label="产品名称：" :label-width="formLabelWidth">
              <span>{{ this.addForm.NAME }}</span>
            </el-form-item>
            <el-form-item label="单位：" :label-width="formLabelWidth">
              <label slot="label">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位：</label>
              <span>{{ this.addForm.TYPE_UNIT }}</span>
            </el-form-item>
            <el-form-item label="单价：" :label-width="formLabelWidth">
              <label slot="label">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价：</label>
              <el-input @keyup.enter.native="submitAdd" v-model="addForm.CURRENT_PRICE" v-if="BE_PRICE === 1" @change="countTotal"></el-input>
              <el-input @keyup.enter.native="submitAdd" v-model="addForm.CURRENT_PRICE" v-else disabled @change="countTotal"></el-input>
            </el-form-item>
            <el-form-item label="订购数量：" :label-width="formLabelWidth">
              <el-input @keyup.enter.native="submitAdd" v-model="addForm.count" @change="countTotal"></el-input>
            </el-form-item>
            <el-form-item label="总金额：" :label-width="formLabelWidth">
              <el-input @keyup.enter.native="submitAdd" v-model="addForm.totalFee" @change="countPrice"></el-input>
            </el-form-item>
            <el-form-item label="备注：" :label-width="formLabelWidth">
              <label slot="label">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</label>
              <el-input @keyup.enter.native="submitAdd" v-model="addForm.comment" maxlength="20" show-word-limit>
              </el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="addFormClose">取 消</el-button>
            <el-button size="small" @click="submitAdd">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
    <el-dialog :visible.sync="exportProductDialog" title="导入商品" width="400px" center>
      <el-form ref="exportProductForm" v-model="exportProductForm">
        <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-remove="handleRemove" :on-success="handleSuccess"
          :name="this.exportProductForm.excel" :multiple="false" :limit="1" accept=".xls,.xlsx" :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传xls/xlsx文件，且不超过500kb
          </div>
        </el-upload>
        <el-form-item>
          <span @click="downLoadExpTemp" style="color: #409eff">点此下载导入模板</span>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button class="operate-btn" @click="closeExport">取消</el-button>
        <el-button class="operate-btn" @click="submitExportPro">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="checkDialog" title="提示" width="400px" center>
      <p style="color: red; margin-left: 20px">
        请核对文件中是否有此供应商不供应的商品
      </p>
      <div slot="footer" style="text-align: center">
        <el-button class="operate-btn" @click="submitCheck">确认</el-button>
      </div>
    </el-dialog>
    <!-- <el-dialog :visible.sync="OtherDialog" title="未能导入的商品" width="400px" center>
            <p style="color: rgb(103, 194, 58)">请核对下列文件中的商品在此供应商中是否匹配</p>
            <el-form ref="OtherForm" v-model="OtherForm">
                <el-form-item>
                    <span @click="downLoadOtherTemp" style="color:#409EFF">点此下载</span>
                </el-form-item>
            </el-form>
            <div slot="footer" style="text-align: center;">
                <el-button class="operate-btn" @click="closeOther">取消</el-button>
                <el-button class="operate-btn" @click="submitOther">确认</el-button>
            </div>
        </el-dialog> -->
    <el-dialog title="选择订单信息" center :visible.sync="copyFormVisible" width="500px" :close-on-click-modal="false">
      <el-form :model="copyForm" ref="copyForm" size="small">
        <el-form-item label="供应商：" prop="GYS" :label-width="formLabelWidth">
          <el-select filterable v-model="copyForm.GYS" clearable style="width: 90%">
            <el-option v-for="item in customers" :key="item.SUPPLIER_ID" :label="item.SUPPLIER_NAME" :value="item.SUPPLIER_ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="送货日期：" prop="SEND_DAY" :label-width="formLabelWidth">
          <el-date-picker :clearable="false" v-model="copyForm.SEND_DAY" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
            style="width: 90%"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="copyFormVisible = false">取 消</el-button>
        <el-button size="small" @click="submitCopy('copyForm')" :loading="copyLoading">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="以下商品在此供应商中无价格" :visible.sync="unCopyVisible" width="600px" center :close-on-click-modal="false">
      <el-table :data="unTableData" border stripe style="width: 100%">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
        <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="产品单位"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="unCopyVisible = false">取 消</el-button>
        <el-button size="small" @click="unCopyVisible = false">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 拆分产品 -->
    <el-dialog title="拆分产品" :visible.sync="sperateVisible" width="600px" center :close-on-click-modal="false">
      <el-table :data="sperateList" border stripe style="width: 100%">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column prop="SUPPLIER_NAME" label="供应商"></el-table-column>
        <el-table-column prop="VENDOR_PRICE" label="价格"></el-table-column>
        <el-table-column label="购买数量">
          <template slot-scope="scope">
            <el-input v-model="scope.row.PRODUCT_COUNT" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="sperateVisible = false">取 消</el-button>
        <el-button size="small" @click="submitSperate">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  exportAll, queryOrderDetailFun, updateOrderFun, deleteOrderDetailFun, chooseEntryFun, addOrderListFun, querySupplierFun, copyProductFun, querySperateFun, submitSperateFun, batchEdit,
} from 'api/shopOrderManage';
import util from '../../assets/common/util';
import http from '../../assets/common/http';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      fromName: ['s_NewOrderList'],
      toName: [],
      loading: false,
      loading1: false,
      BE_PRICE: Number(sessionStorage.getItem('BE_PRICE')),
      checkDialog: false,
      OtherForm: {},
      OtherDialog: false,
      exportProductDialog: false,
      exportProductForm: {},
      orderCode: sessionStorage.getItem('orderCode'),
      orderId: sessionStorage.getItem('orderId'),
      tableData: [],
      editFormVisible: false,
      editForm: {},
      formLabelWidth: '120px',
      searchForm: {},
      firstForm: {},
      addForm: {
        CURRENT_PRICE: '',
        count: '',
        totalFee: '',
      },
      PRODUCT_NAME: '',
      TYPE_UNIT: '',
      addFormVisible: false,
      file_name: '',
      fileList: [],
      checkedArray: [],
      copyFormVisible: false,
      unCopyVisible: false,
      unTableData: [],
      copyForm: {},
      customers: [],
      copyLoading: false,
      submitArr: [],
      sperateVisible: false,
      sendDay: '',
      sperateList: [],
      sperateInfo: {},
      CAN_MODIFY_PRICE: sessionStorage.getItem('CAN_MODIFY_PRICE'),
      isisdisabled: false,
      checkData: [],
      statusFlag: 0,
      rids: [],
      rcounts: [],
      purchaseDetailIDList: [],
      tcNameList: [],
      tcNameRids: [],
      tcNameRcounts: [],
      titleList: [],
    };
  },
  beforeRouteLeave(to, from, next) {
    // 离开页面前清除订单ID
    if (!this.toName.includes(to.name)) {
      sessionStorage.removeItem('orderId');
    }
    next();
  },
  beforeRouteEnter(to, from, next) {
    next((that) => {
      // 判断是否通过修改URL进入
      if (!that.fromName.includes(from.name) || !sessionStorage.getItem('orderId')) {
        that.$message.show({ text: '请从待送订单进入配送中心订单详情', type: 'warning' });
        that.$router.go(-1);
      } else {
        // 控制是否可以自行修改价格
        if (Number(that.CAN_MODIFY_PRICE) === 1) {
          that.isisdisabled = false;
        } else {
          that.isisdisabled = true;
        }
        that.queryTable();
      }
    });
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总价';
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (column.property === 'TOTAL_FEE') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            }
            return prev;
          }, 0);
          sums[index] += ' 元';
        }
      });

      return sums;
    },
    // input框回车自动聚焦下一个input框
    handelTab(i, e) {
      const that = this;
      if (that.$refs[`input${i}`]) {
        that.$nextTick(() => {
          e.target.blur();
          const index = i + 1;
          that.$refs[`input${index}`].focus();
        });
      }
    },
    // 提交手动录入数据以及重新聚焦第一个input框
    handelTabSp(e) {
      this.submitAdd();
      const that = this;
      e.target.blur();
      that.$refs.input1.focus();
      //  this.addForm.PRICE=''
      // this.addForm.count=''
      // this.addForm.comment=''
    },
    // ----------------------导入
    allExport() {
      this.exportProductDialog = true;
    },
    handleSuccess(response, file, fileList) {
      this.file_name = response.file_name;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.file_name = '';
    },
    downLoadExpTemp() {
      window.location.href = 'http://47.99.59.146/file/tmp/PurchaseOrderListModule.xls';
    },
    closeExport() {
      this.exportProductDialog = false;
      this.exportProductForm = {};
    },
    submitExportPro() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            ORDER_ID: Number(sessionStorage.getItem('orderId')),
            FILE_NAME: this.file_name,
          };
          exportAll(params)
            .then((result) => {
              if (result[0].FLAG === 0) {
                this.$message.show({ text: '导入成功', type: 'success' });
                this.file_name = '';
                this.$refs.upload.clearFiles();
                this.queryTable();
                this.exportProductDialog = false;
                this.exportProductForm = {};
                document.body.style.cursor = 'default';
              } else {
                this.exportProductDialog = false;
                this.file_name = '';
                this.$refs.upload.clearFiles();
                this.checkDialog = true;
                document.body.style.cursor = 'default';
              }
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              this.file_name = '';
              this.$refs.upload.clearFiles();
              document.body.style.cursor = 'default';
            });
        } finally {}
      }
    },
    submitCheck() {
      this.checkDialog = false;
    },
    // ------------------录入完成
    finishEntry() {
      this.$router.push({ name: 's_NewOrderList' });
    },
    // ------------------搜索
    querySearch(queryString, callback) {
      this.$_getSearchRushOrderList(queryString).then((res) => {
        const tmpArr = res.map((item) => ({
          BRAND: item.BRAND,
          CURRENT_PRICE: item.CURRENT_PRICE,
          ID: item.ID,
          INNER_CODE: item.INNER_CODE,
          NAME: item.NAME,
          TYPE_UNIT: item.TYPE_UNIT,
          value: item.value,
          count: 0,
          totalFee: 0,
        }));
        const results = tmpArr.map((item) => {
          item.value = `${item.NAME}(${item.TYPE_UNIT})`;
          return item;
        });
        callback(results);
      });
    },
    //  点击搜索结果返回选中的结果
    handleSelect(item) {
      this.addForm = item;
      this.PRODUCT_NAME = item.NAME;
      this.TYPE_UNIT = item.TYPE_UNIT;
      // this.addFormVisible = true
    },
    // addFormClose () {
    //     this.addFormVisible = false
    // },
    addFormClose() {
      this.addFormVisible = false;
    },
    // ---------------------------添加·产品·确认·按钮
    submitAdd() {
      this.addOrderProduct();
    },
    addOrderProduct() {
      if (!this.firstForm.productName) {
        this.$message.show({ text: '请输入产品名称', type: 'warning' });
        return false;
      }
      if (!validation.价格正数验证(this.addForm.CURRENT_PRICE)) {
        this.$message.show({ text: '请输入正数单价', type: 'warning' });
        return false;
      }
      if (!validation.数量正数验证(this.addForm.count) || this.addForm.count <= 0) {
        this.$message.show({ text: '请输入正数订购数量', type: 'warning' });
        return false;
      }
      if (!util.JudgmentUnit(this.addForm.TYPE_UNIT)) { // 如果不是
        const beInter = (this.addForm.count % 1 === 0);
        if (beInter == false) {
          this.$message.show({ text: '单位不是KG的，只能输入整数', type: 'warning' });
          return false;
        }
      }
      const params = {
        ORDER_ID: Number(sessionStorage.getItem('orderId')),
        PRODUCT_COUNT: Number(this.addForm.count),
        PRODUCT_CODE: this.addForm.INNER_CODE,
        PRODUCT_FEE: Number(this.addForm.totalFee),
      };
      if (this.addForm.CURRENT_PRICE) {
        params.PRICE = Number(this.addForm.CURRENT_PRICE);
      }
      if (this.addForm.comment) {
        params.PRODUCT_COMMENT = this.addForm.comment;
      }
      this.loading1 = true;
      addOrderListFun(params)
        .then((result) => {
          this.addFormVisible = false;
          this.$message.show({ text: '新增成功', type: 'success' });
          this.firstForm.productName = '';
          this.addForm = {};
          this.firstForm.productName = '';
          this.loading1 = false;
          this.queryTable();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.firstForm.productName = '';
          this.addForm = {};
          this.loading1 = false;
        });
    },
    // 搜索接口调用
    $_getSearchRushOrderList(NAME) {
      const data = {
        PRODUCT_NAME: this.firstForm.productName,
        SUPPLIER_ID: Number(sessionStorage.getItem('supplierId')),
        PROJECT_ID: Number(sessionStorage.getItem('projectId')),
        ORDER_ID: Number(sessionStorage.getItem('orderId')),
        SEND_DAY: sessionStorage.getItem('SEND_DAY'),
      };
      return new Promise((resolve, reject) => {
        chooseEntryFun(data)
          .then((res) => {
            if (res[0].list.length === 0) {
              this.$message.show({ text: '暂无数据', type: 'warning' });
              resolve([]);
            } else {
              resolve(res[0].list);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // -----------------------------------拉取数据
    queryTable() {
      const params = {
        SERVICE_ID: '10003',
        OTYPE: 44,
        ORDER_ID: sessionStorage.getItem('orderId'),
      };
      http.post(params).then((res) => {
        sessionStorage.setItem('SEND_DAY', res[0].TITLE[0].SEND_DAY);
        if (res[0].DETAIL.length !== 0) {
          this.purchaseDetailIDList = [];
          this.tableData = res[0].DETAIL;
          this.titleList = res[0].TITLE[0];
          this.sendDay = res[0].TITLE[0].SEND_DAY;
          this.checkData = res[0].OR[0].DATA;
          this.statusFlag = res[0].OR[0].RN;
          this.purchaseDetailIDList = res[0].DETAIL.map((item) => item.PURCHASE_DETAIL_ID);
          this.tcNameList = res[0].DETAIL.map((item) => ({ PURCHASE_DETAIL_ID: item.PURCHASE_DETAIL_ID, TC_NAME: item.TC_NAME }));
          this.isRepeated();
        } else {
          this.tableData = [];
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    deleteProduct(row) {
      this.$confirm('确定从订单中删除此商品吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const delParams = {
          ORDER_DETAIL_ID: row.ORDER_DETAIL_ID,
        };
        deleteOrderDetailFun(delParams).then((_result) => {
          this.$message.show({ text: '删除成功', type: 'success' });
          const params = {
            ORDER_ID: sessionStorage.getItem('orderId'),
          };
          queryOrderDetailFun(params)
            .then((result) => {
              sessionStorage.setItem('SEND_DAY', result[0].TITLE[0].SEND_DAY);
              if (result[0].DETAIL.length !== 0) {
                this.tableData = result[0].DETAIL;
                this.sendDay = result[0].TITLE[0].SEND_DAY;
                this.checkData = result[0].OR[0].DATA;
                this.statusFlag = result[0].OR[0].RN;
              } else {
                this.$message.show({ text: '订单已删除，返回到待送订单列表', type: 'success' });
                this.$router.push({ name: 's_NewOrderList' });
              }
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
            });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }).catch(() => {
        this.$message.show({ type: 'info', text: '已取消删除' });
      });
    },
    editProduct(row) {
      this.editFormVisible = true;
      this.editForm = row;
    },
    // ------------------------------修改订单详情
    updateOrderDate() {
      if (!validation.价格正数0验证(this.editForm.REAL_PRICE)) {
        this.$message.show({ text: '请输入正数单价', type: 'warning' });
        return false;
      }
      if (!validation.数量正数验证(this.editForm.PRODUCT_COUNT)) {
        this.$message.show({ text: '请输入正数订购数量', type: 'warning' });
        return false;
      }
      if (!util.JudgmentUnit(this.editForm.TYPE_UNIT)) { // 如果不是
        const beInter = (this.editForm.PRODUCT_COUNT % 1 === 0);
        if (beInter == false) {
          this.$message.show({ text: '单位不是KG的，只能输入整数', type: 'warning' });
          return false;
        }
      }
      if (Number(this.editForm.PRODUCT_COUNT) <= 0) {
        this.$confirm('确定从订单中删除此商品吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          const delParams = {
            ORDER_DETAIL_ID: this.editForm.ORDER_DETAIL_ID,
          };
          deleteOrderDetailFun(delParams)
            .then((result) => {
              this.$message.show({ text: '删除成功', type: 'success' });
              this.editFormVisible = false;
              this.queryTable();
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
            });
        }).catch(() => {
          this.$message.show({ text: '已取消操作', type: 'info' });
        });
      } else {
        const updateParams = {
          PRODUCT_CODE: Number(this.editForm.PRODUCT_CODE),
          NEW_COUNT: Number(this.editForm.PRODUCT_COUNT),
          ORDER_DETAIL_ID: Number(this.editForm.ORDER_DETAIL_ID),
          PRODUCT_COMMENT: this.editForm.PRODUCT_COMMENT,
          MODIFY_REAL_FLAG: 1,
          PRODUCT_FEE: Number(this.editForm.TOTAL_FEE),
          ORDER_ID: Number(sessionStorage.getItem('orderId')),
        };
        if (this.editForm.REAL_PRICE) {
          updateParams.PRICE = Number(this.editForm.REAL_PRICE);
        }
        // if(this.editForm.PRODUCT_COMMENT){
        //     updateParams.PRODUCT_COMMENT = this.editForm.PRODUCT_COMMENT
        // }
        this.loading = true;
        updateOrderFun(updateParams)
          .then((result) => {
            this.$message.show({ text: '修改成功', type: 'success' });
            this.editFormVisible = false;
            this.queryTable();
            this.loading = false;
          }).catch((error) => {
            this.loading = false;
            this.$message.show({ text: error, type: 'error' });
          });
      }
    },
    submitEdit() {
      this.updateOrderDate();
    },
    close() {
      this.editFormVisible = false;
      this.queryTable();
    },
    handleSelectionChange(val) {
      this.checkedArray = val;
    },
    copyAllProduct() {
      if (this.checkedArray.length !== 0) {
        this.copyFormVisible = true;
        this.submitArr = [];
        const tmpArr = this.checkedArray.map((item) => ({ DETAIL_ID: item.ORDER_DETAIL_ID }));
        tmpArr.forEach((item, index) => {
          this.submitArr.push(item.DETAIL_ID);
        });
        this.queryCustomer(this.submitArr);
      } else {
        this.$message.show({ text: '请选择产品', type: 'warning' });
      }
    },
    // 移动商品模态框提交
    submitCopy() {
      if (!this.copyForm.GYS || !this.copyForm.SEND_DAY) {
        this.$message.show({ text: '请选择供应商和送货日期', type: 'warning' });
        return false;
      }
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            DEST_SUPPLIER_ID: this.copyForm.GYS,
            SEND_DAY: this.copyForm.SEND_DAY,
            ORDER_ID: Number(sessionStorage.getItem('orderId')),
            DETAIL_IDS: this.submitArr,
            SOUR_SUPPLIER_ID: Number(sessionStorage.getItem('supplierId')),
          };
          this.copyLoading = true;
          copyProductFun(params).then((result) => {
            this.copyLoading = false;
            if (result[0].DATA.length !== 0) {
              this.copyFormVisible = false;
              this.unTableData = result[0].DATA;
              this.unCopyVisible = true;
            } else {
              this.loading = false;
              this.copyFormVisible = false;
              this.$message.show({ text: '移动成功', type: 'success' });
              this.queryTable();
            }
          }).catch((error) => {
            this.copyLoading = false;
            this.$message.show({ text: error, type: 'error' });
          });
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },
    // -------------------------------拉取供应商信息
    queryCustomer(data) {
      const params = {
        DETAIL_IDS: data,
        SUPPLIER_ID: Number(sessionStorage.getItem('supplierId')),
      };
      querySupplierFun(params).then((result) => {
        if (result.length !== 0) {
          this.customers = result;
        } else {
          this.customers = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    changePrice() {
      if (this.editForm.PRODUCT_COUNT != 0) {
        this.editForm.REAL_PRICE = Math.round((this.editForm.TOTAL_FEE / this.editForm.PRODUCT_COUNT) * 100) / 100;
      }
    },
    countFee() {
      this.editForm.TOTAL_FEE = Math.round((this.editForm.REAL_PRICE * this.editForm.PRODUCT_COUNT) * 100) / 100;
    },
    countTotal() {
      if (this.addForm.CURRENT_PRICE != '' && this.addForm.count != '') {
        this.addForm.totalFee = Math.round((this.addForm.CURRENT_PRICE * this.addForm.count) * 100) / 100;
      }
    },
    countPrice(e) {
      if (this.addForm.count != 0) {
        this.addForm.CURRENT_PRICE = Math.round((this.addForm.totalFee / this.addForm.count) * 100) / 100;
      }
    },
    // 拆分产品
    sperateProduct(row) {
      this.sperateVisible = true;
      this.sperateInfo = row;
      const params = {
        SEND_DAY: this.sendDay,
        PRODUCT_CODE: row.PRODUCT_CODE,
      };
      querySperateFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.sperateList = result.map((item) => Object.assign(item, { BUY_COUNT: '' }));
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 确认拆分
    submitSperate() {
      const subArr = this.sperateList.map((item) => ({ SUPPLIER_ID: item.SUPPLIER_ID, PRODUCT_COUNT: item.PRODUCT_COUNT ? item.PRODUCT_COUNT : 0, PRICE: item.VENDOR_PRICE }));
      const params = {
        ORDER_ID: Number(sessionStorage.getItem('orderId')),
        DETAIL_ID: this.sperateInfo.ORDER_DETAIL_ID,
        TOTAL_COUNT: this.sperateInfo.PRODUCT_COUNT,
        NEW_DETAIL_ARRAY: subArr,
        SEND_DAY: this.sendDay,
        PRODUCT_CODE: this.sperateInfo.PRODUCT_CODE,
      };
      submitSperateFun(params)
        .then((result) => {
          this.$message.show({ text: '拆分成功', type: 'success' });
          this.sperateVisible = false;
          this.queryTable();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 价格限制为正整数或二位小数
    validateNumber(value) {
      value = value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g, '');
      value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
      if (value.indexOf('.') !== value.lastIndexOf('.')) {
        const index = value.lastIndexOf('.');
        value = value.substr(0, index);
      }
      return value;
    },
    // 限制单价
    validatPrice(value) {
      value = this.validateNumber(value);
      this.addForm.CURRENT_PRICE = value;
      this.countTotal();
    },
    // 限制总价
    validatTotal(value) {
      value = this.validateNumber(value);
      this.addForm.totalFee = value;
      this.countPrice();
    },
    countChange() {
      if (this.addForm.CURRENT_PRICE != '') {
        this.countTotal();
      } else if (this.addForm.totalFee != '') {
        this.countPrice();
      }
    },
    objectSpanMethod({
      row, column, rowIndex, columnIndex,
    }) {
      const tmpSet = new Set(this.purchaseDetailIDList);
      if (tmpSet.size != this.purchaseDetailIDList.length) {
        if (columnIndex != 11 && columnIndex != 12 && columnIndex != 13 && columnIndex != 14) {
          if (columnIndex == 10) {
            if (this.tcNameRids.includes(rowIndex)) {
              return {
                rowspan: this.tcNameRcounts[this.tcNameRids.indexOf(rowIndex)],
                colspan: 1,
              };
            }
            return {
              rowspan: -1,
              colspan: -1,
            };
          }
          if (this.rids.includes(rowIndex)) {
            return {
              rowspan: this.rcounts[this.rids.indexOf(rowIndex)],
              colspan: 1,
            };
          }
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    isRepeated() {
      const tmpSet = new Set(this.purchaseDetailIDList);
      if (tmpSet.size != this.purchaseDetailIDList.length) {
        tmpSet.forEach((item1) => {
          let i = 0;
          this.purchaseDetailIDList.forEach((item2) => {
            if (item1 == item2) { i++; }
          });
          this.rids.push(this.purchaseDetailIDList.indexOf(item1));
          this.rcounts.push(i);
        });
      }
      const tmpSet2 = new Set(this.tcNameList);
      if (tmpSet2.size != this.tcNameList.length) {
        tmpSet2.forEach((item1) => {
          let i = 0;
          this.tcNameList.forEach((item2) => {
            if (JSON.stringify(item1) == JSON.stringify(item2)) {
              i++;
            }
          });
          this.tcNameRids.push(this.tcNameList.indexOf(item1));
          this.tcNameRcounts.push(i);
        });
      }
    },
    indexMethod(index) {
      return [...new Set(this.purchaseDetailIDList)].indexOf(this.tableData[index].PURCHASE_DETAIL_ID) + 1;
    },
    // 修改订购数量
    setProductCount(row) {
      if (!(/\d/.test(row.PRODUCT_COUNT))) {
        this.$message.show({ text: '请输入正确的数量', type: 'warning' });
        row.PRODUCT_COUNT = 0;
        return false;
      }
      row.TOTAL_FEE = (Math.round((row.REAL_PRICE * row.PRODUCT_COUNT) * 100) / 100).toFixed(2);
    },
    // 批量修改
    editAllProduct() {
      this.tableData.forEach((item) => {
        item.ORDER_DETAIL_ID = item.PURCHASE_DETAIL_ID;
      });
      const params = {
        SUPPLIER_ID: this.titleList.SUPPLIER_ID,
        GYS_ID: this.titleList.GYS_ID,
        ORDER_ID: Number(sessionStorage.getItem('orderId')),
        DETAIL_DATA: this.tableData,
        MODIFY_REAL_FLAG: 1,
      };
      batchEdit(params).then((result) => {
        this.$message.show({ text: '批量修改成功', type: 'success' });
        this.queryTable();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>
<style>
.inline-input {
  width: 390px;
}

.el-autocomplete-suggestion {
  width: 420px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/shopOrderManage/s_distributionCenterPendingOrderDetail.vue